var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit, QueryList, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { CustomDefaultPlaceCategoryItemSelectionStore } from '../../../stores/hub.calendar.store';
import { CustomDefaultPlaceCategory } from '../../../commands/pagination.query.command';
import { AllFrontendSettingsStore } from '../../../stores/visitor.calendar.store';
import { HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { NestedMenusComponent } from '../../../common/components/nested.menu/nested.menu.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { PlaceService } from '../../../services/place.service';
var CustomDefaultPlaceCategoryAccordionComponent = /** @class */ (function (_super) {
    __extends(CustomDefaultPlaceCategoryAccordionComponent, _super);
    function CustomDefaultPlaceCategoryAccordionComponent(formBuilder, activatedRoute, allFrontendSettingsStore, customDefaultPlaceCategoryItemSelectionStore) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.customDefaultPlaceCategoryItemSelectionStore = customDefaultPlaceCategoryItemSelectionStore;
        _this.loadingToggles = false;
        _this.selectedCategory = 'All';
        _this.menuType = 'default';
        _this.title = 'FILTER BY CATEGORY';
        _this.toggleAndSource = new HubVisitorToggleDataSource();
        _this.menuMode = 'sidebar';
        _this.useNonLeafMenuClick = false;
        _this.onCategoryClick = new EventEmitter();
        _this.onNormalCategoryClick = new EventEmitter();
        _this.onNonLeafClick = new EventEmitter();
        return _this;
    }
    CustomDefaultPlaceCategoryAccordionComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, menuType = _a.menuType;
        this.hubName = hubName;
        setTimeout(function () {
            if (_this.selectedCategory && _this.selectedCategory !== 'All') {
                if (_this.menuType === 'custom') {
                    _this.initialCategoryForCustomInUrlMode = _this.selectedCategory;
                }
                _this.setFilter(_this.selectedCategory);
            }
        }, 1600);
    };
    Object.defineProperty(CustomDefaultPlaceCategoryAccordionComponent.prototype, "isShowThingsToDo", {
        get: function () {
            return (!this.loadingToggles &&
                (this.toggleAndSource.toggle.placeCategory.activity ||
                    this.toggleAndSource.toggle.placeCategory.art ||
                    this.toggleAndSource.toggle.placeCategory.outdoor ||
                    this.toggleAndSource.toggle.placeCategory.entertainment));
        },
        enumerable: true,
        configurable: true
    });
    CustomDefaultPlaceCategoryAccordionComponent.prototype.isSelected = function (title) {
        return this.selectedCategory === title;
    };
    CustomDefaultPlaceCategoryAccordionComponent.prototype.selectCustomDefaultPlaceCategory = function ($event) {
        // selected 'all'
        if (typeof $event === 'string') {
            if (this.menuType !== 'custom') {
                localStorage.removeItem(localStorageKeys.selectedPlaceCategory);
                this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
            }
            else {
                this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.setFilter(this.initialCategoryForCustomInUrlMode);
            }
            this.filterPlace($event);
        }
        else {
            var categoryList = [];
            PlaceService.getAllSubCategories($event, categoryList);
            $event.categoryList = categoryList;
            this.selectedCategory = $event.title;
            this.setFilter($event.title);
            // for map view
            delete $event['subMenuEleRef'];
            var data = this.menuType === 'custom'
                ? $event
                : {
                    title: $event.title,
                    categoryList: $event.categoryList,
                };
            // localStorage.setItem(localStorageKeys.selectedPlaceCategory, JSON.stringify(data));
            this.onCategoryClick.emit($event);
        }
    };
    CustomDefaultPlaceCategoryAccordionComponent.prototype.nonLeafClick = function (node) {
        if (this.useNonLeafMenuClick) {
            var categoryList = [];
            PlaceService.getAllSubCategories(node, categoryList);
            node.categoryList = categoryList;
            this.close();
            this.onNonLeafClick.emit(node);
        }
    };
    CustomDefaultPlaceCategoryAccordionComponent.prototype.filterPlace = function ($event) {
        this.selectedCategory = $event;
        this.onNormalCategoryClick.emit($event);
        if ($event === 'All') {
            // for changing the selection style
            this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.next($event);
            if (this.menuType !== 'custom') {
                this.accordion && this.accordion.clearFilter(null, false);
                localStorage.removeItem(localStorageKeys.selectedPlaceCategory);
            }
        }
        else {
            this.accordion && this.accordion.setFilter($event);
            localStorage.setItem(localStorageKeys.selectedPlaceCategory, $event);
        }
        this.menuMode === 'topbar' && this.accordion && this.accordion.close();
    };
    CustomDefaultPlaceCategoryAccordionComponent.prototype.setFilter = function (title) {
        if (!title) {
            this.clearFilter();
            return;
        }
        var category = PlaceService.getCustomDefaultPlaceCategoryById(title, this.customDefaultPlaceCategory);
        // const category = this.customDefaultPlaceCategory.customCategories.find(
        //     (x) => x.title === title || x._id === title
        // );
        if (category) {
            this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.setFilter(category.title);
            this.accordion && this.accordion.setFilter(category.title);
        }
    };
    CustomDefaultPlaceCategoryAccordionComponent.prototype.clearFilter = function () {
        this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
        this.accordion && this.accordion.clearFilter(null, false);
    };
    CustomDefaultPlaceCategoryAccordionComponent.prototype.close = function () {
        this.accordion && this.accordion.close();
    };
    return CustomDefaultPlaceCategoryAccordionComponent;
}(BaseComponent));
export { CustomDefaultPlaceCategoryAccordionComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component..ts.pre-build-optimizer.js